type ReplacementAction = 'smart-replace' | 'selected-replacement' | 'no-replacement' | "smart-sustitution" | "selected-sustitution";


interface ProductDecision {
    productId: number | string;
    action: ReplacementAction;
    replacementIds: (number | string)[];
}




/**
 * Display labels for each replacement action.
 * These are shown in the cart item row to summarize the user's preference.
 */
const REPLACEMENT_ACTION_LABELS: Record<ReplacementAction, string> = {
    "smart-replace": "Mejor alternativa",
    "selected-replacement": "Solo seleccionados",
    "no-replacement": "No reemplazar",
    "smart-sustitution": "Sustitución automática",
    "selected-sustitution": "Solo seleccionados",
};

export type { ProductDecision, ReplacementAction };
export { REPLACEMENT_ACTION_LABELS };